import getBaseUrl from "lib/utils/getBaseUrl";

interface OneLinerHighlightsParagraphProps {
  paragraph: string;
}

export default function OneLinerHighlightsParagraph({ paragraph }: OneLinerHighlightsParagraphProps) {
  return (
    <div className="flex w-full flex-col items-center gap-3 rounded-lg bg-blue-50 p-2 xl:rounded-full">
      <div className="flex w-full space-x-3">
        <div className="h-10 w-10 overflow-hidden rounded-full bg-neutral-200 ring-2 ring-blue-600 ring-offset-2">
          <img
            src={`${getBaseUrl()}/static/people/v2/eduardo.png`}
            alt="Eduardo Cavalcanti"
            className="aspect-square object-cover"
          />
        </div>
        <div className="flex flex-col space-y-0.5">
          <h3 className="text-sm font-semibold drop-shadow-2xl md:text-sm">Eduardo Cavalcanti</h3>
          <p className="hidden text-sm tracking-wide text-gray-500 xl:flex">{paragraph}</p>
          <p className="flex text-xs font-normal italic tracking-wide text-gray-500 xl:hidden">
            CEO & Cofundador do Fundamentei
          </p>
        </div>
      </div>
      <p className="flex w-full text-left text-sm tracking-wide text-gray-500 xl:hidden">{paragraph}</p>
    </div>
  );
}
